import {vignetService} from '../services/vignets.services';



export const fetchVignetsData = ( data ) => dispatch => {
    let vignetsList = vignetService.getAllVignets(data);
    vignetsList.then(vignetsList => {
        dispatch({
            type: "VIGNETS_DATA_SUCCESS",
            vignetsList
        });
    });

}
export const fetchmoreVignetsData = ( data ) => dispatch => {
    let vignetsList = vignetService.getAllVignets(data);
    vignetsList.then(vignetsList => {
        dispatch({
            type: "LOAD_MORE_VIGNETS_DATA",
            vignetsList
        });
    });

}

export const getProjects = ( data ) => dispatch => {
    let projectList = vignetService.getProjects(data);
    projectList.then(projectList => {
        dispatch({
            type: "LOAD_PROJECT_DATA",
            projectList
        });
    });

}

export const setSelectedItems = (name, value) => dispatch => {
    dispatch({
        type: 'SET_SELECTED_ITEMS',
        name : name,
        value : value
    })
}


/*export const vignetsData = ( state ) => dispatch => {

    /*dispatch({
        type:"VIGNETS_DATA_LOADING",
        isLoading: bool
    });

    dispatch({
        type:"VIGNETS_DATA_ERROR",
        hasError: bool
    });

    dispatch({
        type:"VIGNETS_DATA_SUCCESS",
        vignetsList : []
    });*/


    /*let vignetsList = vignetService.getAllVignets({user_id:'u5003ffa658949'});

    vignetsList.then(vignetsList => {
        dispatch({
            type: "VIGNETS_DATA_SUCCESS",
            vignetsList
        });
    });
}*/

export function vignetsDataRequest(data) {
    return vignetService.getAllVignets(data);


    /*return {
        type: 'VIGNETS_DATA_REQUEST',
        data
    };*/
}

export function vignetsDataError(bool) {
    return {
        type: 'VIGNETS_DATA_ERROR',
        hasError: bool
    };
}


export function vignetsDataSuccess(vignetsList) {
    return {
                type: 'VIGNETS_DATA_SUCCESS',
                vignetsList
    };
}




export const chooseVignets = ( id ) => dispatch => {

    dispatch({
        type: "SELECT_VIGNETS",
        id
    });
}

export const clearVignets = ( id ) => dispatch => {

    dispatch({
        type: "CLEAR_VIGNETS",
        id
    });
}
export const vignetsSelected = (state ) => dispatch => {
    dispatch({
        type:"VIGNETS_SELECTED",
        state
    });
}


export const removeSelection = ( state ) => dispatch => {

    dispatch({
        type: "REMOVE_SELECTION",
        state
    });
}



export const deleteVignets = ( ids ) => dispatch => {
    let deleted = vignetService.deleteVignets({"vigids" :ids});

    deleted.then(function (res) {

        if( res.data.response=== 'success' ) {
            dispatch({
                type: "DELETE_VIGNETS",
                ids
            });

            /*let vignetsList = vignetService.getAllVignets({userid:'u5003ffa658949'});
            vignetsList.then(vignetsList => {
                dispatch({
                    type: "VIGNETS_DATA_SUCCESS",
                    vignetsList
                });
            });*/
        }
    })



}


export const searchVignets = ( data ) => dispatch => {
    let filteredData = data.vignetsList;
    let searchvalue = data.search_text;

    if(searchvalue !== '') {
        filteredData = filteredData.filter(
            item => item.vignet_title.toLowerCase().search(searchvalue.toLowerCase()) >= 0
        )
    }

    if(data.sort === 'new') {
        // filteredData.sort(function(a, b){
        //     var dateA=new Date(parseInt(a.create_time)), dateB=new Date(parseInt(b.create_time))
        //     return dateB-dateA //sort by date ascending
        // });
        filteredData.sort(function(a, b){
            return b.id-a.id
        });
    }
    else if(data.sort === 'old') {
        // filteredData.sort(function(a, b){
        //     var dateA=new Date(parseInt(a.create_time)), dateB=new Date(parseInt(b.create_time))
        //     return dateA-dateB //sort by date descending
        // });
        filteredData.sort(function(a, b){
            return a.id-b.id
        });
    }
    else if(data.sort === 'az') {
        filteredData.sort(function(a, b){
            if(a.vignet_title !== undefined && b.vignet_title !== undefined) {
                var nameA=a.vignet_title.toLowerCase(), nameB=b.vignet_title.toLowerCase()
                if (nameA < nameB) //sort string ascending
                    return -1
                if (nameA > nameB)
                    return 1
            }
            else
                return 0 //default return value (no sorting)
        });
    }
    else if(data.sort === 'za') {
        filteredData.sort(function(a, b){
            if(a.vignet_title !== undefined && b.vignet_title !== undefined) {
                var nameA=a.vignet_title.toLowerCase(), nameB=b.vignet_title.toLowerCase()
                if (nameA > nameB) //sort string ascending
                    return -1
                if (nameA < nameB)
                    return 1
            }
            else
                return 0 //default return value (no sorting)
        });
    }

    dispatch({
        type: "VIGNETS_DATA_SEARCH_SUCCESS",
        filteredData : filteredData,
        searchText : data.search_text,
        sort : data.sort,
        userid : data.userid

    });
}

export const getVignetDetail = ( data ) => dispatch => {

    let vignetDetail = vignetService.getVignetDetail(data);

    vignetDetail.then(vignetDetail => {
        dispatch({
            type: "VIGNET_DETAIL_SUCCESS",
            vignetDetail
        });
    });
}

export const createVignet = (data ) => dispatch => {

    let created = vignetService.createVignet(data);

    created.then(created => {
        dispatch({
            type: "CREATE_VIGNET",
            created
        });
    });
}

export const fetchGraphData = (data) => dispatch => {
    let analyticsData = vignetService.getGraphData(data);
    analyticsData.then(analyticsData => {
        dispatch({
            type: "VIGNET_GRAPH",
            analyticsData,
            index : data.index,
            section_name : data.section_name
        });
    });
}

export const saveTags = (data ) => dispatch => {

    let saved = vignetService.saveTags(data);

    saved.then(saved => {
        dispatch({
            type: "SAVE_TAGS",
            saved
        });
    });
}

export const removeTags = (data ) => dispatch => {

    let removed = vignetService.removeTags(data);

    removed.then(removed => {
        dispatch({
            type: "REMOVE_TAGS",
            removed
        });
    });
}

export const saveNote = (data ) => dispatch => {

    let saved = vignetService.saveNote(data);

    saved.then(saved => {
        dispatch({
            type: "SAVE_NOTE",
            saved
        });
    });
}

export const getVignetProps = (data ) => dispatch => {

    dispatch({
        type: "SET_VIG_PROPS",
        index : data.index,
    });

    let vignetProps = vignetService.getVignetProps(data);

    vignetProps.then(vignetProps => {
        dispatch({
            type: "GET_VIG_PROPS",
            vignetProps,
            index : data.index,
            section_name : data.section_name
        });
    });
}

export const getVignetTags = (data ) => dispatch => {

    let vignetTags = vignetService.getVignetTags(data);

    vignetTags.then(vignetTags => {
        dispatch({
            type: "GET_VIG_TAGS",
            vignetTags
        });
    });
}

export const getVignetNotes = (data ) => dispatch => {

    let vignetNotes = vignetService.getVignetNotes(data);

    vignetNotes.then(vignetNotes => {
        dispatch({
            type: "GET_VIG_NOTES",
            vignetNotes
        });
    });
}

export const getVignetProjects = (data ) => dispatch => {

    let vignetProjects = vignetService.getVignetProjects(data);

    vignetProjects.then(vignetProjects => {
        dispatch({
            type: "GET_VIG_PROJECTS",
            vignetProjects
        });
    });
}

export const joinVignets = (data ) => dispatch => {

    let saved = vignetService.joinVignets(data);

    saved.then(saved => {
       /* dispatch({
            type: "CREATE_VIGNET",
            saved
        });*/

        dispatch({
            type: "JOIN_VIGNETS",
            saved
        });
    });
}


export function toggleModal(data) {

    return {
        type: 'TOGGLE_VIG_MODAL',
        modalOpen : data.modalOpen,
        modalTitle : data.modalTitle,
        modalType : data.modalType
    };
}




// WEBPACK FOOTER //
// ./src/actions/vignets.js